import {
    AddResidentDTO,
    changeNodePresenceDTO,
    changeNodePresenceSocket,
    DisconnectAndEditDTO,
    EditResidentDTO,
    FallDetectedRuleSocket,
    MoveResidentWithDeviceDTO,
    MoveResidentWithDeviceResponceDTO,
    MoveResidentWithDevicesBySocketDTO,
    Resident,
    residentsReqOptions,
    ResidentsSettings,
} from '.';
import { ModalTypes } from '../../components/modals/residents/AllModals';
import { ADDDeviceResidentDTO, DeviceResidentDTO } from '../devices';
import { assignAlertsBatchDTO, IBaseRule, RulesIds } from '../residentRules/';
import { ResidentStatusesSocket } from '../residentStatuses';

export enum RESIDENTS {
    ADD_RESIDENT_REQUEST = 'RESIDENTS.ADD_RESIDENT_REQUEST',
    ADD_RESIDENT_SUCCESS = 'RESIDENTS.ADD_RESIDENT_SUCCESS',
    ADD_RESIDENT_FAILURE = 'RESIDENTS.ADD_RESIDENT_FAILURE',

    ADD_MANY_RESIDENT_REQUEST = 'RESIDENTS.ADD_MANY_RESIDENT_REQUEST',
    ADD_MANY_RESIDENT_SUCCESS = 'RESIDENTS.ADD_MANY_RESIDENT_SUCCESS',
    ADD_MANY_RESIDENT_FAILURE = 'RESIDENTS.ADD_MANY_RESIDENT_FAILURE',

    GET_RESIDENTS_REQUEST = 'RESIDENTS.GET_RESIDENTS_REQUEST',
    GET_RESIDENTS_SUCCESS = 'RESIDENTS.GET_RESIDENTS_SUCCESS',
    GET_RESIDENTS_FAILURE = 'RESIDENTS.GET_RESIDENTS_FAILURE',

    GET_RESIDENTS_RULES_ALERTS_STATUSES_REQUEST = 'RESIDENTS.GET_RESIDENTS_RULES_ALERTS_STATUSES_REQUEST',
    GET_RESIDENTS_RULES_ALERTS_STATUSES_SUCCESS = 'RESIDENTS.GET_RESIDENTS_RULES_ALERTS_STATUSES_SUCCESS',
    GET_RESIDENTS_RULES_ALERTS_STATUSES_FAILURE = 'RESIDENTS.GET_RESIDENTS_RULES_ALERTS_STATUSES_FAILURE',

    GET_ONE_RESIDENT_REQUEST = 'RESIDENTS.GET_ONE_RESIDENT_REQUEST',
    GET_ONE_RESIDENT_SUCCESS = 'RESIDENTS.GET_ONE_RESIDENT_SUCCESS',
    GET_ONE_RESIDENT_FAILURE = 'RESIDENTS.GET_ONE_RESIDENT_FAILURE',
    EDIT_RESIDENT_REQUEST = 'RESIDENTS.EDIT_RESIDENT_REQUEST',
    EDIT_RESIDENT_SUCCESS = 'RESIDENTS.EDIT_RESIDENT_SUCCESS',
    EDIT_RESIDENT_FAILURE = 'RESIDENTS.EDIT_RESIDENT_FAILURE',

    DELETE_RESIDENT_REQUEST = 'RESIDENTS.DELETE_RESIDENT_REQUEST',
    DELETE_RESIDENT_SUCCESS = 'RESIDENTS.DELETE_RESIDENT_SUCCESS',
    DELETE_RESIDENT_FAILURE = 'RESIDENTS.DELETE_RESIDENT_FAILURE',

    ADD_RESIDENT_BY_SOCKET = 'RESIDENTS.ADD_RESIDENT_BY_SOCKET',
    UPDATE_RESIDENT_BY_SOCKET = 'RESIDENTS.UPDATE_RESIDENT_BY_SOCKET',
    DELETE_RESIDENT_BY_SOCKET = 'RESIDENTS.DELETE_RESIDENT_BY_SOCKET',

    GET_DEVICES_REQUEST = 'RESIDENTS.GET_DEVICES_REQUEST',
    GET_DEVICES_SUCCESS = 'RESIDENTS.GET_DEVICES_SUCCESS',
    GET_DEVICES_FAILURE = 'RESIDENTS.GET_DEVICES_FAILURE',

    ADD_DEVICE_REQUEST = 'RESIDENTS.ADD_DEVICE_REQUEST',
    ADD_DEVICE_SUCCESS = 'RESIDENTS.ADD_DEVICE_SUCCESS',
    ADD_DEVICE_FAILURE = 'RESIDENTS.ADD_DEVICE_FAILURE',

    DELETE_DEVICE_REQUEST = 'RESIDENTS.DELETE_DEVICE_REQUEST',
    DELETE_DEVICE_SUCCESS = 'RESIDENTS.DELETE_DEVICE_SUCCESS',
    DELETE_DEVICE_FAILURE = 'RESIDENTS.DELETE_DEVICE_FAILURE',

    CHANGE_RULE_REQUEST = 'RESIDENTS.CHANGE_RULE_REQUEST',
    CHANGE_RULE_SUCCESS = 'RESIDENTS.CHANGE_RULE_SUCCESS',
    CHANGE_RULE_FAILURE = 'RESIDENTS.CHANGE_RULE_FAILURE',

    GET_RULE_REQUEST = 'RESIDENTS.GET_RULE_REQUEST',
    GET_RULE_SUCCESS = 'RESIDENTS.GET_RULE_SUCCESS',
    GET_RULE_FAILURE = 'RESIDENTS.GET_RULE_FAILURE',

    BATCH_CHANGE_REQUEST = 'RESIDENTS.BATCH_CHANGE_REQUEST',
    BATCH_CHANGE_SUCCESS = 'RESIDENTS.BATCH_CHANGE_SUCCESS',
    BATCH_CHANGE_FAILURE = 'RESIDENTS.BATCH_CHANGE_FAILURE',

    SET_SETTINGS = 'RESIDENTS.SET_LIST_SETTINGS',
    CHANGE_SELECTED = 'RESIDENTS.CHANGE_SELECTED',
    RESOLVE_ALERT_REQUEST = 'RESIDENTS.RESOLVE_ALERT_REQUEST',
    RESOLVE_ALERT_FAILURE = 'RESIDENTS.RESOLVE_ALERT_FAILURE',
    RESOLVE_ALERT_SUCCESS = 'RESIDENTS.RESOLVE_ALERT_FAILURE',

    DELETE_BATCH_DEVICE_REQUEST = 'RESIDENTS.DELETE_BATCH_DEVICE_REQUEST',
    DELETE_BATCH_DEVICE_SUCCESS = 'RESIDENTS.DELETE_BATCH_DEVICE_SUCCESS',
    DELETE_BATCH_DEVICE_FAILURE = 'RESIDENTS.DELETE_BATCH_DEVICE_FAILURE',

    DELETE_MANY_RESIDENTS_REQUEST = 'RESIDENTS.DELETE_MANY_RESIDENTS_REQUEST',
    DELETE_MANY_RESIDENTS_SUCCESS = 'RESIDENTS.DELETE_MANY_RESIDENTS_SUCCESS',
    DELETE_MANY_RESIDENTS_FAILURE = 'RESIDENTS.DELETE_MANY_RESIDENTS_FAILURE',

    BATCH_DISCONNECT_AND_CHANGE_REQUEST = 'RESIDENTS.BATCH_DISCONNECT_AND_CHANGE_REQUEST',
    BATCH_DISCONNECT_AND_CHANGE_SUCCESS = 'RESIDENTS.BATCH_DISCONNECT_AND_CHANGE_SUCCESS',
    BATCH_DISCONNECT_AND_CHANGE_FAILURE = 'RESIDENTS.BATCH_DISCONNECT_AND_CHANGE_FAILURE',

    MOVE_RESIDENT_WITH_DEVICES_REQUEST = 'RESIDENTS.MOVE_RESIDENT_WITH_DEVICES_REQUEST',
    MOVE_RESIDENT_WITH_DEVICES_SUCCESS = 'RESIDENTS.MOVE_RESIDENT_WITH_DEVICES_SUCCESS',
    MOVE_RESIDENT_WITH_DEVICES_FAILURE = 'RESIDENTS.MOVE_RESIDENT_WITH_DEVICES_FAILURE',

    GET_RESIDENT_RULES_REQUEST = 'RESIDENTS.GET_RESIDENT_RULES_REQUEST',
    GET_RESIDENT_RULES_SUCCESS = 'RESIDENTS.GET_RESIDENT_RULES_SUCCESS',
    GET_RESIDENT_RULES_FAILURE = 'RESIDENTS.GET_RESIDENT_RULES_FAILURE',

    DELETE_DEVICE_FROM_RESIDENT_BYSOCKET = 'RESIDENTS.DELETE_DEVICE_FROM_RESIDENT_BYSOCKET',
    ADD_DEVICE_TO_RESIDENT_BY_SOCKET = 'RESIDENTS.ADD_DEVICE_TO_RESIDENT_BY_SOCKET',

    UPDATE_THRESHOLD_RULE_BY_SOCKET = 'RESIDENTS.UPDATE_THRESHOLD_RULE_BY_SOCKET',
    UPDATE_PRESSURE_ULCER_RULE_BY_SOCKET = 'RESIDENTS.UPDATE_PRESSURE_ULCER_RULE_BY_SOCKET',
    UPDATE_FALL_PREVENTION_RULE_BY_SOCKET = 'RESIDENTS.UPDATE_FALL_PREVENTION_RULE_BY_SOCKET',
    UPDATE_EPILEPSY_RULE_BY_SOCKET = 'RESIDENTS.UPDATE_EPILEPSY_RULE_BY_SOCKET',
    UPDATE_FALL_DETECTED_RULE_BY_SOCKET = 'RESIDENTS.UPDATE_FALL_DETECTED_RULE_BY_SOCKET',
    MOVE_RESIDENT_WITH_DEVICES_BY_SOCKET = 'RESIDENTS.MOVE_RESIDENT_WITH_DEVICES_BY_SOCKET',
    UPDATE_STATUSES_BY_SOCKET = 'RESIDENTS.UPDATE_STATUSES_BY_SOCKET',

    CHANGE_FAKE_RULE_REQUEST = 'RESIDENTS.CHANGE_FAKE_RULE_REQUEST',

    GET_RESIDENTS_PICTURES_REQUEST = 'RESIDENTS.GET_RESIDENTS_PICTURES_REQUEST',
    GET_RESIDENTS_PICTURES_SUCCESS = 'RESIDENTS.GET_RESIDENTS_PICTURES_SUCCESS',
    GET_RESIDENTS_PICTURES_FAILURE = 'RESIDENTS.GET_RESIDENTS_PICTURES_FAILURE',

    CHANGE_NODE_PRESENCE_REQUEST = 'RESIDENTS.CHANGE_NODE_PRESENCE_REQUEST',
    CHANGE_NODE_PRESENCE_BY_SOCKET = 'RESIDENTS.CHANGE_NODE_PRESENCE_BY_SOCKET',
    CHANGE_NODE_PRESENCE_SUCCESS = 'RESIDENTS.CHANGE_NODE_PRESENCE_SUCCESS',
    CHANGE_NODE_PRESENCE_FAILURE = 'RESIDENTS.CHANGE_NODE_PRESENCE_FAILURE',

    CHANGE_RULES_BATCH_REQUEST = 'RESIDENTS.CHANGE_RULES_BATCH_REQUEST',
    // CHANGE_RULES_BATCH_BY_SOCKET = 'RESIDENTSCHANGE_RULES_BATCH_BY_SOCKET',
    CHANGE_RULES_BATCH_SUCCESS = 'RESIDENTS.CHANGE_RULES_BATCH_SUCCESS',
    CHANGE_RULES_BATCH_FAILURE = 'RESIDENTS.CHANGE_RULES_BATCH_FAILURE',
}

export interface IAddResidentRequest {
    type: typeof RESIDENTS.ADD_RESIDENT_REQUEST;
    payload: AddResidentDTO;
}

export interface IAddResidentSuccess {
    type: typeof RESIDENTS.ADD_RESIDENT_SUCCESS;
    payload: any;
}

export interface IAddResidentFailure {
    type: typeof RESIDENTS.ADD_RESIDENT_FAILURE;
    payload: any;
}

export interface IAddManyResidentRequest {
    type: typeof RESIDENTS.ADD_MANY_RESIDENT_REQUEST;
    payload: AddResidentDTO[];
}

export interface IAddManyResidentSuccess {
    type: typeof RESIDENTS.ADD_MANY_RESIDENT_SUCCESS;
    payload: any;
}

export interface IAddManyResidentFailure {
    type: typeof RESIDENTS.ADD_MANY_RESIDENT_FAILURE;
    payload: any;
}

export interface IGetResidentsRequest {
    type: typeof RESIDENTS.GET_RESIDENTS_REQUEST;
    payload: { options: residentsReqOptions; blocking: boolean };
}

export interface IGetResidentsSuccess {
    type: typeof RESIDENTS.GET_RESIDENTS_SUCCESS;
    payload: any;
}

export interface IGetResidentsFailure {
    type: typeof RESIDENTS.GET_RESIDENTS_FAILURE;
    payload: any;
}

export interface IGetOneResidentRequest {
    type: typeof RESIDENTS.GET_ONE_RESIDENT_REQUEST;
    payload: { residentId: string };
}

export interface IGetOneResidentSuccess {
    type: typeof RESIDENTS.GET_ONE_RESIDENT_SUCCESS;
    payload: Resident;
}

export interface IGetOneResidentFailure {
    type: typeof RESIDENTS.GET_ONE_RESIDENT_FAILURE;
    payload: any;
}

export interface IEditResidentRequest {
    type: typeof RESIDENTS.EDIT_RESIDENT_REQUEST;
    payload: EditResidentDTO;
}

export interface IEditResidentSuccess {
    type: typeof RESIDENTS.EDIT_RESIDENT_SUCCESS;
    payload: any;
}

export interface IEditResidentFailure {
    type: typeof RESIDENTS.EDIT_RESIDENT_FAILURE;
    payload: any;
}

export interface IDeleteResidentRequest {
    type: typeof RESIDENTS.DELETE_RESIDENT_REQUEST;
    payload: { residentId: string };
}

export interface IDeleteResidentSuccess {
    type: typeof RESIDENTS.DELETE_RESIDENT_SUCCESS;
    payload: any;
}

export interface IDeleteResidentFailure {
    type: typeof RESIDENTS.DELETE_RESIDENT_FAILURE;
    payload: any;
}

export interface IDeleteResidentBySocket {
    type: typeof RESIDENTS.DELETE_RESIDENT_BY_SOCKET;
    payload: { id: string; nodeId: number };
}
export interface IAddResidentBySocket {
    type: typeof RESIDENTS.ADD_RESIDENT_BY_SOCKET;
    payload: Resident;
}
export interface IUpdateResidentBySocket {
    type: typeof RESIDENTS.UPDATE_RESIDENT_BY_SOCKET;
    payload: Resident;
}

export interface IChangeRuleRequest {
    type: typeof RESIDENTS.CHANGE_RULE_REQUEST;
    payload: { residentId: string; rule: IBaseRule };
}

export interface IChangeFakeRuleRequest {
    type: typeof RESIDENTS.CHANGE_FAKE_RULE_REQUEST;
    payload: { residentId: string; rule: IBaseRule };
}

export interface IChangeRuleSuccess {
    type: typeof RESIDENTS.CHANGE_RULE_SUCCESS;
    payload: any;
}

export interface IChangeRuleFailure {
    type: typeof RESIDENTS.CHANGE_RULE_FAILURE;
    payload: any;
}

export interface IGetRuleRequest {
    type: typeof RESIDENTS.GET_RULE_REQUEST;
    payload: { residentId: string; rule: RulesIds };
}

export interface IGetRuleSuccess {
    type: typeof RESIDENTS.GET_RULE_SUCCESS;
    payload: { residentId: string; rule: IBaseRule };
}

export interface IGetRuleFailure {
    type: typeof RESIDENTS.GET_RULE_FAILURE;
    payload: any;
}

export interface IGetResidentRulesRequest {
    type: typeof RESIDENTS.GET_RESIDENT_RULES_REQUEST;
    payload: { residentId: string };
}

export interface IGetResidentRulesSuccess {
    type: typeof RESIDENTS.GET_RESIDENT_RULES_SUCCESS;
    payload: { residentId: string; rules: IBaseRule[] };
}

export interface IGetResidentRulesFailure {
    type: typeof RESIDENTS.GET_RESIDENT_RULES_FAILURE;
    payload: any;
}

export interface IAddResidentDeviceRequest {
    type: typeof RESIDENTS.ADD_DEVICE_REQUEST;
    payload: { residentID: string; deviceId: string };
}

export interface IAddResidentDeviceSuccess {
    type: typeof RESIDENTS.ADD_DEVICE_SUCCESS;
    payload: any;
}

export interface IAddResidentDeviceFailure {
    type: typeof RESIDENTS.ADD_DEVICE_FAILURE;
    payload: any;
}

export interface IDeleteResidentDeviceRequest {
    type: typeof RESIDENTS.DELETE_DEVICE_REQUEST;
    payload: { residentID: string; deviceId: string };
}

export interface IDeleteResidentDeviceSuccess {
    type: typeof RESIDENTS.DELETE_DEVICE_SUCCESS;
    payload: any;
}

export interface IDeleteResidentDeviceFailure {
    type: typeof RESIDENTS.DELETE_DEVICE_FAILURE;
    payload: any;
}

export interface IBatchResidentsPutRequest {
    type: typeof RESIDENTS.BATCH_CHANGE_REQUEST;
    payload: { residents: EditResidentDTO[]; isMoved: boolean };
}

export interface IBatchResidentsPutSuccess {
    type: typeof RESIDENTS.BATCH_CHANGE_SUCCESS;
    payload: any;
}

export interface IBatchResidentsPutFailure {
    type: typeof RESIDENTS.BATCH_CHANGE_FAILURE;
    payload: any;
}

export interface ISetResidentsSettings {
    type: typeof RESIDENTS.SET_SETTINGS;
    payload: ResidentsSettings;
}

export interface IChangeResidentsSelected {
    type: typeof RESIDENTS.CHANGE_SELECTED;
    payload: string;
}
export interface IDeleteBatchDevicesFromResidentsRequest {
    type: typeof RESIDENTS.DELETE_BATCH_DEVICE_REQUEST;
    payload: DeviceResidentDTO[];
}
export interface IDeleteBatchDevicesFromResidentsSuccess {
    type: typeof RESIDENTS.DELETE_BATCH_DEVICE_SUCCESS;
    payload: DeviceResidentDTO[];
}

export interface IDeleteDeviceFromResidentBySocket {
    type: typeof RESIDENTS.DELETE_DEVICE_FROM_RESIDENT_BYSOCKET;
    payload: DeviceResidentDTO;
}
export interface IAddDeviceToResidentBySocket {
    type: typeof RESIDENTS.ADD_DEVICE_TO_RESIDENT_BY_SOCKET;
    payload: ADDDeviceResidentDTO;
}

export interface IDeleteBatchDevicesFromResidentsFailure {
    type: typeof RESIDENTS.DELETE_BATCH_DEVICE_FAILURE;
    payload: any;
}

export interface IDeleteManyResidentsRequest {
    type: typeof RESIDENTS.DELETE_MANY_RESIDENTS_REQUEST;
    payload: string[];
}
export interface IDeleteManyResidentsSuccess {
    type: typeof RESIDENTS.DELETE_MANY_RESIDENTS_SUCCESS;
    payload: string[];
}
export interface IDeleteManyResidentsFailure {
    type: typeof RESIDENTS.DELETE_MANY_RESIDENTS_FAILURE;
    payload: any;
}

export interface IBatchDisconectAndChangeResidentsRequest {
    type: typeof RESIDENTS.BATCH_DISCONNECT_AND_CHANGE_REQUEST;
    payload: { data: DisconnectAndEditDTO[]; reason: ModalTypes };
}
export interface IBatchDisconectAndChangeResidentsSuccess {
    type: typeof RESIDENTS.BATCH_DISCONNECT_AND_CHANGE_SUCCESS;
    payload: DisconnectAndEditDTO[];
}
export interface IBatchDisconectAndChangeResidentsFailure {
    type: typeof RESIDENTS.BATCH_DISCONNECT_AND_CHANGE_FAILURE;
    payload: any;
}
export interface IGetFallDetectedRuleBySocket {
    type: typeof RESIDENTS.UPDATE_FALL_DETECTED_RULE_BY_SOCKET;
    payload: FallDetectedRuleSocket;
}

export interface IMoveResidentWithDevicesBySoket {
    type: typeof RESIDENTS.MOVE_RESIDENT_WITH_DEVICES_BY_SOCKET;
    payload: MoveResidentWithDevicesBySocketDTO;
}

export interface IUpdateResidentStatusesBySoket {
    type: typeof RESIDENTS.UPDATE_STATUSES_BY_SOCKET;
    payload: ResidentStatusesSocket;
}
export interface IDeleteManyResidentsSuccess {
    type: typeof RESIDENTS.DELETE_MANY_RESIDENTS_SUCCESS;
    payload: string[];
}
export interface IDeleteManyResidentsFailure {
    type: typeof RESIDENTS.DELETE_MANY_RESIDENTS_FAILURE;
    payload: any;
}

export interface IMoveResidentWithDevicesRequest {
    type: typeof RESIDENTS.MOVE_RESIDENT_WITH_DEVICES_REQUEST;
    payload: MoveResidentWithDeviceDTO;
}
export interface IMoveResidentWithDevicesSuccess {
    type: typeof RESIDENTS.MOVE_RESIDENT_WITH_DEVICES_SUCCESS;
    payload: MoveResidentWithDeviceResponceDTO[];
}
export interface IMoveResidentWithDevicesFailure {
    type: typeof RESIDENTS.MOVE_RESIDENT_WITH_DEVICES_FAILURE;
    payload: any;
}

export interface IGetResidentsPicturesRequest {
    type: typeof RESIDENTS.GET_RESIDENTS_PICTURES_REQUEST;
}

export interface IGetResidentsPicturesSuccess {
    type: typeof RESIDENTS.GET_RESIDENTS_PICTURES_SUCCESS;
    payload: any[];
}

export interface IGetResidentsPicturesFailure {
    type: typeof RESIDENTS.GET_RESIDENTS_PICTURES_FAILURE;
    payload: any;
}

export interface IGetResidentsStuffRequest {
    type: typeof RESIDENTS.GET_RESIDENTS_RULES_ALERTS_STATUSES_REQUEST;
}

export interface IGetResidentsStuffSuccess {
    type: typeof RESIDENTS.GET_RESIDENTS_RULES_ALERTS_STATUSES_SUCCESS;
    payload: any[];
}

export interface IGetResidentsStuffFailure {
    type: typeof RESIDENTS.GET_RESIDENTS_RULES_ALERTS_STATUSES_FAILURE;
    payload: any;
}

export interface IChangeNodePresenceRequest {
    type: typeof RESIDENTS.CHANGE_NODE_PRESENCE_REQUEST;
    payload: changeNodePresenceDTO;
}

export interface IChangeNodePresenceSocket {
    type: typeof RESIDENTS.CHANGE_NODE_PRESENCE_BY_SOCKET;
    payload: changeNodePresenceSocket;
}

export interface IChangeNodePresenceSuccess {
    type: typeof RESIDENTS.CHANGE_NODE_PRESENCE_SUCCESS;
    payload: any;
}

export interface IChangeNodePresenceFailure {
    type: typeof RESIDENTS.CHANGE_NODE_PRESENCE_FAILURE;
    payload: any;
}

export interface IChangeRulesBatchRequest {
    type: typeof RESIDENTS.CHANGE_RULES_BATCH_REQUEST;
    payload: assignAlertsBatchDTO;
}

export interface IChangeRulesBatchSuccess {
    type: typeof RESIDENTS.CHANGE_RULES_BATCH_SUCCESS;
    payload: assignAlertsBatchDTO;
}

export interface IChangeRulesBatchFailure {
    type: typeof RESIDENTS.CHANGE_RULES_BATCH_FAILURE;
    payload: any;
}
export type ResidentRequestTypes =
    | IAddResidentRequest
    | IAddManyResidentRequest
    | IGetResidentsRequest
    | IGetOneResidentRequest
    | IEditResidentRequest
    | IDeleteResidentRequest
    | IGetOneResidentRequest
    | IChangeRuleRequest
    | IGetRuleRequest
    | IAddResidentDeviceRequest
    | IDeleteResidentDeviceRequest
    | IBatchResidentsPutRequest
    | ISetResidentsSettings
    | IChangeResidentsSelected
    | IDeleteBatchDevicesFromResidentsRequest
    | IDeleteManyResidentsRequest
    | IBatchDisconectAndChangeResidentsRequest
    | IMoveResidentWithDevicesRequest
    | IGetResidentsStuffRequest;

export type ResidentSuccessTypes =
    | IAddResidentSuccess
    | IAddManyResidentSuccess
    | IGetResidentsSuccess
    | IEditResidentSuccess
    | IDeleteResidentSuccess
    | IGetOneResidentSuccess
    | IChangeRuleSuccess
    | IGetRuleSuccess
    | IAddResidentDeviceSuccess
    | IDeleteResidentDeviceSuccess
    | IBatchResidentsPutSuccess
    | IDeleteBatchDevicesFromResidentsSuccess
    | IDeleteManyResidentsSuccess
    | IBatchDisconectAndChangeResidentsSuccess
    | IMoveResidentWithDevicesSuccess
    | IGetResidentsPicturesSuccess
    | IGetResidentsStuffSuccess;

export type ResidentFailureTypes =
    | IAddResidentFailure
    | IAddManyResidentFailure
    | IGetResidentsFailure
    | IEditResidentFailure
    | IDeleteResidentFailure
    | IGetOneResidentFailure
    | IChangeRuleFailure
    | IGetRuleFailure
    | IAddResidentDeviceFailure
    | IDeleteResidentDeviceFailure
    | IBatchResidentsPutFailure
    | IDeleteBatchDevicesFromResidentsFailure
    | IDeleteManyResidentsFailure
    | IBatchDisconectAndChangeResidentsFailure
    | IMoveResidentWithDevicesFailure
    | IGetResidentsStuffFailure;

export type ResidentActionTypes =
    | ResidentRequestTypes
    | ResidentSuccessTypes
    | ResidentFailureTypes
    | IDeleteResidentBySocket
    | IAddResidentBySocket
    | IUpdateResidentBySocket
    | IDeleteDeviceFromResidentBySocket
    | IAddDeviceToResidentBySocket
    | IGetFallDetectedRuleBySocket
    | IMoveResidentWithDevicesBySoket
    | IUpdateResidentStatusesBySoket
    | IGetResidentRulesRequest
    | IGetResidentRulesSuccess
    | IGetResidentRulesFailure
    | IChangeFakeRuleRequest
    | IChangeNodePresenceSocket;
